import { IUpdateFeedDTO } from '@/models/feeds.model';
import { TFeedFormValues } from '../helpers/types';
import CreateFeedDTO from './CreateFeedDTO';

class UpdateFeedDTO extends CreateFeedDTO implements IUpdateFeedDTO {
  id: string;

  constructor(values: TFeedFormValues & { id: string }) {
    super(values);
    this.id = values.id;
  }
}

export default UpdateFeedDTO;
